<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择用药的老人</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <div>
                    <el-row style="float: right;margin:10px 0">
                        <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                        <!-- <el-select
                            v-model="status"
                             style="margin:0 10px;width:200px"
                            placeholder="请选择状态">
                            <el-option
                                v-for="(item,i) in statusValue"
                                :key="i"
                                :label="item"
                                :value="i">
                            </el-option>
                        </el-select> -->
                        <el-button type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                    </el-row>
                    <div style="clear: both;"></div>
                </div>
                 <template>
                <el-table :data="tableData" height="500" border>

                    <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                    <el-table-column label="手机号" prop="phone"></el-table-column>
                    <el-table-column label="身份证号" prop="idCard"></el-table-column>
                    <el-table-column label="部门" prop="departmentName"></el-table-column>
                    <el-table-column label="地址" prop="areaName" ></el-table-column>
                    <el-table-column label="详细地址" prop="address" ></el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="primary" size="small" @click.native.prevent="handleAdd(scope.$index, scope.row)">添加</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Add",
        data() {
            return {

                loading: false,
                add_waresCode:'',
                pageSize:20,
                currentPage:1,
                showModalAdd:false,
                tableData:[],
                waresList:[],
                status:0,
                totalItems: 0,
                th:0,
                statusValue:['老人状态','正常','禁用'],
                name:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    address:'',
                },

                rules:{
                    name:[
                        { required: true, message: '物品名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入库存', trigger: 'blur' },
                        { type: 'number', message: '库存必须为数字值'}
                    ],
                }


            }
        },

        methods: {
            init(){
                this.getElderly();
                // var list=getTokenBykey('waresInfoAdd');
            },
            closeSelf() {
                this.$emit("closeGetElderly");
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getElderly();
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            handleAdd(index,row){
                this.$emit("closeGetElderly");
                this.$emit('openAdd',row)
            },
            changeWares(selVal){
                this.add_waresCode=selVal;
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getElderly(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Elderly/Page',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        status:0,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then((response)=> {
                    if(response.data.error == 0){
                        this.tableData=response.data.data.list
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style  lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:1180px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 20px 0;
        z-index: 99;
        height: 100%;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>